// アプリの提供形態フラグ
//
// 2026-08: 無料・個人向けアプリとして提供する方針に伴い、課金UIとチーム機能を
// 非表示化。コード・DB・Edge Functionsはすべて残っているため、フラグを true に
// 戻すだけで再開できる。
//
// 注意:
// - TEAMS_ENABLED=false でも既存のチームプロジェクト自体は一覧に表示される
//   （データを隠さない）。新規のチーム作成・共有の入口だけを閉じる。
// - AI機能の利用回数制限（Free: 月3回等）はサーバー側で継続。APIコストの安全弁。

/** 課金関連UI（料金プラン・請求管理・紹介プログラム・アップグレード訴求・特商法表記） */
export const BILLING_ENABLED = false

/** チーム機能（チーム管理ページ・プロジェクトのチーム共有） */
export const TEAMS_ENABLED = false

/** リンク共有（招待リンクを開いたログインユーザーがプロジェクトに参加できる） */
export const LINK_SHARING_ENABLED = true
